import { Stack, Typography } from "@mui/material";
import "./MyPasswordFeedbackMessage.scss";
import ButtonElement from "../UI/ButtonElement/ButtonElement";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import theme from "../../muiTheme";

interface MyPasswordFeedbackMessageProps {
  handleClick?: () => void;
}

const MyPasswordFeedbackMessage = ({
  handleClick,
}: MyPasswordFeedbackMessageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack className="my-password-feeback-message">
      <Stack fontSize="25px" alignItems="center" width="100%">
        <div
          className="t-icon-check"
          style={{
            backgroundColor: theme.palette.success.main,
            padding: "8px",
            color: "#fff",
            borderRadius: "100px",
            margin: "auto",
          }}
        ></div>
      </Stack>
      <Typography variant="h2" paddingY="1.5rem">
        {t("Mi contraseña.Contraseña cambiada correctamente")}
      </Typography>
      <ButtonElement
        onClick={() =>
          handleClick ? handleClick() : navigate(process.env.REACT_APP_HOME!)
        }
        secondary
        modal
      >
        {t("Mi contraseña.Volver al inicio")}
      </ButtonElement>
    </Stack>
  );
};

export default MyPasswordFeedbackMessage;
